import React from "react";
import { connect } from "react-redux";

import * as S from "@styled";
import { DispatchType } from "shared/utilities";
import CustomModal from "shared/components/CustomModal";

import { ProcessTemplate } from "processTemplates/model/ProcessTemplate";

import * as ProcessListActions from "processList/actions/ProcessListActions";
import { State } from "processList/model/State";

const SelectCreateTemplateFromProcessModeDialog: React.FC<SelectCreateTemplateFromProcessModeDialogProps> = (props) => {
    const handleClose = () => {
        props.closeSelectCreateTemplateFromProcessModeDialog();
    };

    const getTemplateNameAndVersion = (template?: ProcessTemplate) => {
        if (!template) {
            return '';
        }
        const { name, majorVersion, minorVersion, version } = template;
        return `${name} ${majorVersion}.${minorVersion}.${version}`;
    };

    const handleUpdateButtonClick = () => {
        if (props.processId && props.existingTemplate) {
            props.openCreateTemplateFromProcessDialog(props.processId, props.existingTemplate);
        }
        handleClose();
    };

    const handleCreateButtonClick = () => {
        if (props.processId) {
            props.openCreateTemplateFromProcessDialog(props.processId);
        }
        handleClose();
    };

    return (
        <CustomModal
            label="select-create-template-from-process-mode-dialog"
            modalTitle={<h2>Update or Create Template from Process</h2>}
            show={!!props.processId}
            onClose={handleClose}
            shouldCloseOnOverlayClick={true}
            size="medium"
        >
            <S.FlexContainer asColumn gap={24}>
                <>
                    <p style={{ margin: 0 }}>
                        {`This Process is based on Template ${getTemplateNameAndVersion(props.existingTemplate)}.`}
                    </p>

                    <S.FlexContainer justifyEnd gap={35}>
                        <S.Button onClick={handleUpdateButtonClick}>
                            {`Update ${getTemplateNameAndVersion(props.existingTemplate)} template`}
                        </S.Button>

                        <S.Button onClick={handleCreateButtonClick}>
                            Create new template
                        </S.Button>
                    </S.FlexContainer>
                </>
            </S.FlexContainer>
        </CustomModal>
    );
};

interface SelectCreateTemplateFromProcessModeDialogStateProps {
    processId?: number;
    existingTemplate?: ProcessTemplate;
}

interface SelectCreateTemplateFromProcessModeDispatchProps {
    closeSelectCreateTemplateFromProcessModeDialog: () => void;
    openCreateTemplateFromProcessDialog: (processId: number, existingTemplate?: ProcessTemplate) => void;
}

type SelectCreateTemplateFromProcessModeDialogProps = SelectCreateTemplateFromProcessModeDialogStateProps & SelectCreateTemplateFromProcessModeDispatchProps;

const mapStateToProps = (state: State): SelectCreateTemplateFromProcessModeDialogStateProps => ({
    processId: state.listState.selectCreateTemplateFromProcessModeModal?.processId,
    existingTemplate: state.listState.selectCreateTemplateFromProcessModeModal?.existingTemplate,
});

const mapDispatchToProps = (dispatch: DispatchType<State>): SelectCreateTemplateFromProcessModeDispatchProps => ({
    closeSelectCreateTemplateFromProcessModeDialog: () => dispatch(ProcessListActions.setSelectCreateTemplateFromProcessModeModal(null)),
    openCreateTemplateFromProcessDialog: (processId: number, existingTemplate?: ProcessTemplate) => dispatch(ProcessListActions.setCreateTemplateFromProcessModal({ processId, existingTemplate }))
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectCreateTemplateFromProcessModeDialog);
